import { createContext, type PropsWithChildren, useContext } from "react"
import { Formik as BaseFormik, type FormikConfig, type FormikValues } from "formik"

// Formik's context drops `validationSchema`, so the schema is re-published here for field wrappers.
const ValidationSchemaContext = createContext<unknown>(undefined)

export function useValidationSchema(): unknown {
    return useContext(ValidationSchemaContext)
}

// For `useFormik` + `FormikProvider` forms, which bypass the `Formik` wrapper below.
export function ValidationSchemaProvider({
    validationSchema,
    children,
}: PropsWithChildren<Readonly<{ validationSchema: unknown }>>) {
    return <ValidationSchemaContext.Provider value={validationSchema}>{children}</ValidationSchemaContext.Provider>
}

export function Formik<Values extends FormikValues>(props: FormikConfig<Values>) {
    return (
        <ValidationSchemaProvider validationSchema={props.validationSchema}>
            <BaseFormik<Values> {...props} />
        </ValidationSchemaProvider>
    )
}
